export const getUserTests = ({ tests }) => tests;
export const getUserTestIsFinished = ({ tests }) =>
    tests.currentTest.isFinished;
export const getUserTestFilterData = ({ tests }) => tests.filter;
export const getUserCurrentTest = ({ tests }) => tests.currentTest;
export const getUserCurrentTestReview = ({ tests }) =>
    tests.currentTestResultReview;
